<div class="p-p-2 center-image aspect-ratio-box" [style.height]="calculateAspectRatioHeight()">
  <img
    [src]="params.value+'?ts=' + timestamp"
    [style]="getImageStyle()"
    (click)="onThumbnailClick()"
  />
</div>
